'use client';

import { type RoadMapUpdate } from '@/domain/roadmap/types';
import { useRoadmapEditStore } from '@/features/roadmap/store/roadmap';
import { TextField } from '@andritzot/metris-web-ui/inputs/textfield';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';
import { type Control, Controller } from 'react-hook-form';

import { FieldActionsWrapper } from './shared/FieldActionsWrapper';

interface ItemFieldProps {
  viewOnly: boolean;
  control: Control<RoadMapUpdate, unknown>;
}

export function ItemField({ viewOnly, control }: Readonly<ItemFieldProps>) {
  const editableRoadMap = useRoadmapEditStore((s) => s.editableRoadMap);

  const history =
    !viewOnly && editableRoadMap.itemChangesCount > 0
      ? { roadmapId: editableRoadMap.idRoadmap, field: 'Item', changesCount: editableRoadMap.itemChangesCount }
      : undefined;

  return (
    <Controller
      name="item"
      control={control}
      rules={{ required: 'Required' }}
      render={({ field, fieldState: { error } }) => (
        <Box sx={{ py: 0.75, width: '100%' }}>
          <FieldActionsWrapper copyValue={field.value ?? ''} history={history}>
            <TextField
              {...field}
              label="Item Name"
              required
              disabled={viewOnly}
              fullWidth
              size="small"
              slotProps={{ htmlInput: { maxLength: 200 } }}
              error={!!error}
              helperText={error?.message}
            />
          </FieldActionsWrapper>
        </Box>
      )}
    />
  );
}
